export enum TipoTopicoAula {
  APRESENTACAO = 'APRESENTACAO',
  CONTEUDO = 'CONTEUDO',
  AVALIACAO = 'AVALIACAO',
  FEEDBACK = 'FEEDBACK',
}
